<template>
    <div
        :class="{
            'ui-select': true,
            '--labelless': labelText === null,
            '--no-options': noOptions,
            '--gray': isGrayTheme,
            '--transparent': isTransparentTheme,
            disabled: disabled,
            unvalid: isUnvalid,
            focus: isFocus,
            contain: isContaining
        }"
    >
        <div class="ui-select__input">
            <label v-if="labelText">{{ labelText }}</label>
            <v-select
                :options="options"
                :label="optionFieldKey"
                :placeholder="placeholder"
                :multiple="multiselect"
                :components="{ Deselect, OpenIndicator }"
                :clearable="isClearable"
                :value="selected"
                :searchable="false"
                @input="updateSelected"
                @open="setIsFocus(true)"
                @close="setIsFocus(false)"
            >
                <template #no-options>{{ textNoOptionsHandled }}</template>
            </v-select>
        </div>
    </div>
</template>

<script>
import VueTypes, { nullable, object } from 'vue-types';
import 'vue-select/dist/vue-select.css';

export default {
    name: 'MySelect',
    props: {
        labelText: VueTypes.oneOfType([String, nullable]).def(null),
        placeholder: VueTypes.oneOfType([String, nullable]).def(null),
        textNoOptions: VueTypes.oneOfType([String, nullable]).def(null),
        value: VueTypes.oneOfType([object, nullable]).def(null),

        multiselect: VueTypes.bool.def(false),
        isClearable: VueTypes.bool.def(true),
        noOptions: VueTypes.bool.def(false),
        disabled: VueTypes.bool.def(false),
        isUnvalid: VueTypes.bool.def(false), // If is error

        optionFieldKey: VueTypes.string.def('name'),
        options: VueTypes.array.def([]),

        theme: VueTypes.oneOf(['default', 'gray', 'transparent']).def('default')
    },
    data() {
        const deselectComponent = this.createComponent('closeIcon');
        const openIndicatorComponent = this.createComponent('arrowRightIcon');

        return {
            Deselect: deselectComponent,
            OpenIndicator: openIndicatorComponent,

            isFocus: false,

            selected: null
        };
    },
    watch: {
        value(newVal, oldVal) {
            this.selected = newVal;
            // this.updateSelected(newVal)
            if (newVal === null && oldVal) this.$emit('deselect');
        }
    },
    computed: {
        isContaining() {
            return this.isSelectedValid ? true : false;
        },
        isSelectedValid() {
            return this.selected !== null && !(Array.isArray(this.selected) && this.selected.length === 0);
        },
        isGrayTheme() {
            return this.theme === 'gray' ? true : false;
        },
        isTransparentTheme() {
            return this.theme === 'transparent' ? true : false;
        },
        textNoOptionsHandled() {
            return this.textNoOptions === null ? this.$t('globalTextAttirbuteNoOptions') : this.textNoOptions;
        }
    },
    methods: {
        createComponent(iconId) {
            const theLink = this.iconLink(iconId);
            return {
                render(createElement) {
                    return createElement('svg', [
                        createElement('use', {
                            attrs: { 'xlink:href': theLink }
                        })
                    ]);
                }
            };
        },
        iconLink(iconId) {
            const spritePath = require('@/themes/novaporta/assets/icons/sprite.svg');
            return `${spritePath}#${iconId}`;
        },

        setIsFocus(flag) {
            this.isFocus = flag;
            this.$emit('toggle-options-window', flag);
        },
        updateSelected(value) {
            this.$emit('input', value);
        }
    },
    mounted() {
        if (this.value) {
            this.selected = this.value;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '~/themes/novaporta/assets/styles/utils.scss';
@import './styles.scss';
</style>
